import { render, staticRenderFns } from "./popdefult.vue?vue&type=template&id=00322f2a&scoped=true&"
import script from "./popdefult.vue?vue&type=script&lang=js&"
export * from "./popdefult.vue?vue&type=script&lang=js&"
import style0 from "./popdefult.vue?vue&type=style&index=0&id=00322f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00322f2a",
  null
  
)

export default component.exports